import React from 'react';
import {
  TextField, Switch, FormControlLabel, Typography, MenuItem,
} from '@mui/material';
import { IntegrationFieldDef } from '../../constants/integrationRegistry';
import { catchyTextFieldSx } from '../../theme/formStyles';

interface Props {
  fields: IntegrationFieldDef[];
  config: Record<string, unknown>;
  onChange: (config: Record<string, unknown>) => void;
}

export const IntegrationConfigFields: React.FC<Props> = ({ fields, config, onChange }) => {
  const setField = (key: string, value: unknown) => {
    onChange({ ...config, [key]: value });
  };

  return (
    <>
      {fields.map((field) => {
        if (field.type === 'boolean') {
          return (
            <FormControlLabel
              key={field.key}
              control={
                <Switch
                  checked={Boolean(config[field.key] ?? field.default ?? false)}
                  onChange={(e) => setField(field.key, e.target.checked)}
                  color="success"
                  size="small"
                />
              }
              label={<Typography fontSize={12}>{field.label}</Typography>}
              sx={{ display: 'block', mb: 0.5 }}
            />
          );
        }

        if (field.type === 'select') {
          return (
            <TextField
              key={field.key}
              select
              label={field.label}
              fullWidth
              size="small"
              sx={{ ...catchyTextFieldSx, mb: 1, mt: 1 }}
              value={String(config[field.key] ?? field.default ?? '')}
              onChange={(e) => setField(field.key, e.target.value)}
            >
              {(field.options || []).map((opt) => (
                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
              ))}
            </TextField>
          );
        }

        return (
          <TextField
            key={field.key}
            label={field.label}
            fullWidth
            size="small"
            type={field.type === 'password' ? 'password' : 'text'}
            placeholder={field.placeholder}
            sx={{ ...catchyTextFieldSx, mb: 1, mt: 1 }}
            value={String(config[field.key] ?? '')}
            onChange={(e) => setField(field.key, e.target.value)}
          />
        );
      })}
    </>
  );
};
